import React from "react";
import { useDispatch } from "react-redux";

import { getPerson as onGetPerson } from "slices/thunks";
import ManageRecordsLink from "Components/Common/RecordManager/ManageRecordsLink";
import { RecordKindConfig } from "Components/Common/RecordManager/types";

/** The record manager's Edit link for a section of the person profile. */
const PersonRecordsLink = ({ person, config }: { person: any; config: RecordKindConfig }) => {
  const dispatch: any = useDispatch();
  return (
    <ManageRecordsLink
      owner={person}
      ownerName={person?.fullName}
      config={config}
      refresh={() => dispatch(onGetPerson({ id: person?.id }))}
    />
  );
};

export default PersonRecordsLink;
